export const situacoesExemplo = [
  {
    id: 1,
    titulo: "Ansiedade ao Falar em Público",
    comportamento: "Fico nervoso e travo quando preciso apresentar",
    gatilho: "Imagino as pessoas me julgando e rindo de mim",
    imagemIndesejada: "Vejo rostos críticos, sinto meu corpo tenso, ouço minha voz tremendo",
    imagemIdeal: "Me vejo confiante, postura ereta, voz firme, público interessado e receptivo"
  },
  {
    id: 2,
    titulo: "Procrastinação no Trabalho",
    comportamento: "Adio tarefas importantes e fico no celular",
    gatilho: "Visualizo a tarefa como uma montanha impossível de escalar",
    imagemIndesejada: "Vejo uma pilha enorme de trabalho, sinto peso no peito, penso 'não vou conseguir'",
    imagemIdeal: "Me vejo focado, trabalhando com leveza, completando uma etapa de cada vez com satisfação"
  },
  {
    id: 3,
    titulo: "Insegurança em Relacionamentos",
    comportamento: "Evito me aproximar de pessoas novas por medo de rejeição",
    gatilho: "Imagino a pessoa me rejeitando ou me achando chato",
    imagemIndesejada: "Vejo a pessoa virando as costas, sinto aperto no peito, ouço 'você não é interessante'",
    imagemIdeal: "Me vejo conversando naturalmente, sorrindo, a pessoa engajada e interessada no que digo"
  },
  {
    id: 4,
    titulo: "Compulsão Alimentar",
    comportamento: "Como compulsivamente quando estou estressado",
    gatilho: "Visualizo a comida como única fonte de conforto",
    imagemIndesejada: "Vejo a comida brilhando, sinto urgência, penso 'preciso disso agora'",
    imagemIdeal: "Me vejo calmo, respirando fundo, escolhendo conscientemente o que é melhor para mim"
  },
  {
    id: 5,
    titulo: "Medo de Dirigir",
    comportamento: "Evito dirigir em rodovias por ansiedade",
    gatilho: "Imagino perdendo o controle do carro ou causando um acidente",
    imagemIndesejada: "Vejo o carro desgovernado, sinto mãos suando, ouço buzinas e gritos",
    imagemIdeal: "Me vejo dirigindo com segurança, mãos firmes no volante, respiração calma, no controle total"
  }
];

export const dicasSwish = [
  "Quanto mais rápido o movimento SWISH, mais eficaz a técnica",
  "A imagem do EU IDEAL deve ser vista de fora, como se você assistisse a um filme",
  "Limpe a tela mental entre cada repetição para evitar sobreposição",
  "Faça pelo menos 7 repetições para instalar o novo padrão",
  "Se a nova imagem não surgir automaticamente, ajuste as qualidades visuais",
  "Use sons mentais durante o SWISH: 'SWISHHH' ou 'ZOOM'",
  "A imagem indesejada deve começar grande, nítida e próxima",
  "A imagem desejada deve começar pequena, distante e menos definida",
  "Teste sempre após as repetições: pense na situação e veja qual imagem surge",
  "Pratique em situações reais para reforçar o novo padrão"
];

export const passosSwish = [
  {
    numero: 1,
    titulo: "Identifique o Comportamento",
    descricao: "Escolha algo específico que deseja mudar",
    icone: "ri-focus-3-line",
    cor: "from-purple-500 to-pink-500"
  },
  {
    numero: 2,
    titulo: "Descubra o Gatilho",
    descricao: "O que passa pela sua mente antes disso acontecer?",
    icone: "ri-flashlight-line",
    cor: "from-pink-500 to-rose-500"
  },
  {
    numero: 3,
    titulo: "Crie o EU IDEAL",
    descricao: "Como você gostaria de reagir nessa situação?",
    icone: "ri-star-line",
    cor: "from-rose-500 to-orange-500"
  },
  {
    numero: 4,
    titulo: "Ajuste as Qualidades",
    descricao: "Configure tamanho, nitidez e proximidade das imagens",
    icone: "ri-settings-3-line",
    cor: "from-orange-500 to-amber-500"
  },
  {
    numero: 5,
    titulo: "Movimento SWISH",
    descricao: "A imagem ideal cresce rápido e ocupa toda a tela",
    icone: "ri-speed-line",
    cor: "from-amber-500 to-yellow-500"
  },
  {
    numero: 6,
    titulo: "Limpe a Tela",
    descricao: "Pense em algo neutro entre cada repetição",
    icone: "ri-eraser-line",
    cor: "from-yellow-500 to-lime-500"
  },
  {
    numero: 7,
    titulo: "Repita 5-10x",
    descricao: "Cada vez mais rápido e automático",
    icone: "ri-repeat-line",
    cor: "from-lime-500 to-emerald-500"
  },
  {
    numero: 8,
    titulo: "Teste o Resultado",
    descricao: "Qual imagem surge primeiro agora?",
    icone: "ri-checkbox-circle-line",
    cor: "from-emerald-500 to-teal-500"
  }
];

export const checklistEuIdeal = [
  { id: 1, item: "Postura corporal confiante" },
  { id: 2, item: "Expressão facial serena e segura" },
  { id: 3, item: "Energia emocional positiva" },
  { id: 4, item: "Segurança e naturalidade" },
  { id: 5, item: "Você se vê de fora (como num filme)" }
];

export const perguntasGatilho = [
  "O que passa pela minha mente imediatamente antes?",
  "Que imagem mental aparece?",
  "Que sensação corporal sinto?",
  "Que pensamento visual tenho?",
  "O que imagino que vai acontecer?"
];
